
import { Textarea } from "@/components/ui/textarea";
import { ArrowUp } from "lucide-react";
import LoadingState from "./LoadingState";
import { useEffect, useRef } from "react";

interface MeetingPromptProps {
  isLoading: boolean;
  prompt: string;
  feedback?: string;
  onPromptChange: (value: string) => void;
  onSubmit: () => void;
  isAuthenticated: boolean;
  isReadyToSchedule?: boolean;
  parsedMeeting?: {
    attendeeName: string | null;
    dateTime: Date | null;
    duration?: number;
  } | null;
  onGoogleSignIn: () => void;
  onSchedule: () => void;
}

const MeetingPrompt = ({
  isLoading,
  prompt,
  onPromptChange,
  onSubmit,
  isAuthenticated,
  isReadyToSchedule,
  parsedMeeting,
  onGoogleSignIn,
  onSchedule,
}: MeetingPromptProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (!isLoading && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [isLoading, prompt]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (prompt.trim()) {
        onSubmit();
      }
    }
  };

  const handleSubmit = () => {
    if (prompt.trim()) {
      onSubmit();
    }
  };

  return (
    <div className="relative">
      <div className="flex items-start gap-4">
        <div className="relative flex-1 shadow-lg rounded-lg">
          <Textarea
            ref={textareaRef}
            value={prompt}
            onChange={(e) => onPromptChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Book a meeting with Aaron tomorrow at 2pm"
            className="min-h-[100px] resize-none text-base placeholder:text-muted-foreground bg-card rounded-lg pr-12 p-4 focus:ring-2 focus:ring-primary/20 focus:border-transparent"
            disabled={isLoading}
          />
          <button 
            className="absolute right-3 bottom-3 p-2 rounded-full bg-[#9b87f5] hover:bg-[#8b5cf6] text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleSubmit}
            disabled={isLoading || !prompt.trim()}
          >
            <ArrowUp className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MeetingPrompt;
